import React from 'react';
import './footer.css';
function Footer() {
  return <div className="footer">María Ten, 2023</div>;
}

export default Footer;
